import type { LocationWeightStatusDto, NewLocation, UpdateLocation } from '@/services/types';

import type { DailyCageWeight, LocationFormInput } from './types';

/** The daily rows of a weight status; a status without rows reads as none. */
export function toDailyCageWeights(
    status: Omit<LocationWeightStatusDto, 'dailyCageWeightRows'> & {
        dailyCageWeightRows?: LocationWeightStatusDto['dailyCageWeightRows'];
    }
): DailyCageWeight[] {
    return status.dailyCageWeightRows ?? [];
}

function parseId(value: number | string): number {
    return Number.parseInt(String(value));
}

function toLocationFields(input: LocationFormInput): UpdateLocation {
    return {
        name: input.name,
        timezone: input.timezone,
        aquacultureSiteId: input.aquacultureSiteId ? parseId(input.aquacultureSiteId) : undefined,
        latitude: input.latitude,
        longitude: input.longitude,
        locationtypeid: parseId(input.locationtypeid),
        // A location without a default species leaves the field out, which keeps it unset;
        // parsing the empty value gave NaN, which reached the API as null.
        fishtypeid:
            input.fishtypeid === null || input.fishtypeid === ''
                ? undefined
                : parseId(input.fishtypeid),
        licetypeid: parseId(input.licetypeid),
    };
}

export function toNewLocationBody(input: LocationFormInput, clientId: number): NewLocation {
    return { ...toLocationFields(input), clientId };
}

export function toUpdateLocationBody(input: LocationFormInput): UpdateLocation {
    return toLocationFields(input);
}
